module.exports = __webpack_public_path__ + "static/img/download.5153dc2b.svg";